import { render, staticRenderFns } from "./MeetingInvitationComponent.vue?vue&type=template&id=04c4c96b&"
import script from "./MeetingInvitationComponent.vue?vue&type=script&lang=js&"
export * from "./MeetingInvitationComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports